import React from "react";
import moment from "moment";
import { Button } from "reactstrap";
import { GET_ROLE_BY_USER_ID } from "@/GraphQL/Queries";
import { useQuery } from "@apollo/client";
// import { SiAuthentik } from "react-icons/si";
const AuthorizeButton = ({ item, authorized, onClick, userData }) => {
  console.log("🚀 ~ AuthorizeButton ~ userData:", item);
  const { data, loading, error } = useQuery(GET_ROLE_BY_USER_ID, {
    variables: { user_id: userData?.user_id },
  });
  console.log("🚀 ~ AuthorizeButton ~ data:", data);

  const ids = [13, 16, 17];
  // Check if login_time exists and if it's after 9:30 AM
  const loginTime = item?.login_time ? moment(item?.login_time) : null;
  const formattedTime = loginTime ? loginTime.format("HH:mm:ss") : null;

  let isAuthorizedTime = false;

  if (
    formattedTime &&
    moment(formattedTime, "HH:mm:ss").isAfter(moment("10:10:00", "HH:mm:ss"))
  ) {
    isAuthorizedTime = true; // If login time is after 9:30 AM
  } else {
    isAuthorizedTime = false; // If login time is before or equal to 9:30 AM
  }

  return (
    <div>
      {isAuthorizedTime && (
        <Button
          className={`btn btn-sm ${authorized ? "bg-success" : ""}`}
          onClick={() => onClick(item)} // Handle click with item.id
        >
          {authorized ? "Authorized" : "Authorize"}
        </Button>
      )}
    </div>
  );
};

export default AuthorizeButton;
